import { IRootState } from 'affiny-core/modules/state';

export const selectCurrentSpecialOffer = (state: IRootState) =>
  state.specialOffer;

export const selectCurrentSpecialOfferCallDone = (state: IRootState) =>
  state.specialOffer.callDone;
